import { useSaveUnavailabilityFetch } from '../../activity-timeline-actions';
import { useSnackbar } from '../../../../../../global/config/useSnackbar';

export const useRunSaveUnavailability = (
  runRefetch: () => void
) => {
  const saveUnavailability = useSaveUnavailabilityFetch();
  const { setSnackbar } = useSnackbar();

  return ( activityEnrolmentId: string, activityDate: string) => {
    if (!activityEnrolmentId) return;
    saveUnavailability
      .run({
        activityEnrolmentId,
        activityDate,
      })
      .then((res) => {
        if (!res.ok) {
          setSnackbar({
            open: true,
            message: 'Unable to save unavailability',
            variant: 'error',
          });
          return;
        }

        setSnackbar({
          open: true,
          message: 'Unavailability saved',
          variant: 'success',
        });
        runRefetch();
      })
      .catch(() =>
        setSnackbar({
          open: true,
          message: 'Unable to save unavailability',
          variant: 'error',
        })
      );
  };
};
